import { render } from "./GfbFormContainer.vue?vue&type=template&id=1bb08d7f"
import script from "./GfbFormContainer.vue?vue&type=script&lang=js"
export * from "./GfbFormContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__